import { create } from 'zustand'
import { AuthState } from '../../types/AuthState'

export const useAuthState = create<AuthState>()(
  (set) => ({
    loginSuccess: false,
    setLoginSuccess: (loginSuccess) => set({ loginSuccess }),
    sessionTimeOut: false,
    setSessionTimeOut: (sessionTimeOut) => set({ sessionTimeOut }),
    showTimeoutWarning: false,
    setShowTimeoutWarning: (val) => set({ showTimeoutWarning: val }),
    sharingSuccess: false,
    setSharingSuccess: (sharingSuccess) => set({ sharingSuccess }),
  })
)

